import {
  FormCreateUserNeedResponse,
  PostApiSpoFormCreateUserNeedBody,
} from '@spo/types';
import { apiBff } from '.';

export const getFormCreateUserNeed = async (
  postApiSpoFormCreateUserNeedBody: PostApiSpoFormCreateUserNeedBody,
): Promise<FormCreateUserNeedResponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/form/create_user_need',
    postApiSpoFormCreateUserNeedBody,
  );
};
